import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const printerNumber = (name, fallback) => (name && name.match(/printer-(\d+)/) ? name.match(/printer-(\d+)/)[1] : fallback);

export default function useOrderPrint({ csrfToken, printing }) {
  const [open, setOpen] = useState(false);
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const openModal = () => {
    setOpen(true);
    if (!printing.useLocalPrint && printing.printersUrl) {
      setLoading(true);
      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      axios.get(printing.printersUrl)
        .then(({ data }) => {
          const list = data || [];
          setPrinters(list);
          if (list.length > 0) {
            const n = printerNumber(list[0].name, 1);
            setSelected({ value: n, label: `Printer ${n}` });
          }
        })
        .catch(() => setPrinters([]))
        .then(() => setLoading(false));
    }
  };

  const closeModal = () => { setOpen(false); setPrinters([]); };

  const printLocal = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.get(printing.localPdfUrl, { responseType: 'blob' }).then((response) => {
      const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const existing = document.getElementById('op-print-iframe');
      if (existing) existing.remove();
      const iframe = document.createElement('iframe');
      iframe.id = 'op-print-iframe';
      iframe.style.position = 'fixed';
      iframe.style.top = '-10000px';
      iframe.style.left = '-10000px';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.src = url;
      iframe.onload = () => {
        try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch (e) { window.open(url, '_blank'); }
        setTimeout(() => {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          URL.revokeObjectURL(url);
        }, 60000);
      };
      document.body.appendChild(iframe);
    });
  };

  const printServer = () => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.get(`${printing.serverPrintUrl}?printer_id=${selected ? selected.value : 1}`);
  };

  const confirmPrint = () => {
    const job = printing.useLocalPrint ? printLocal() : printServer();
    return job
      .then(() => { if (!printing.useLocalPrint) toast.success('Printing…', { position: toast.POSITION.TOP_CENTER, hideProgressBar: true }); })
      .catch(() => toast.error('Could not print tickets. Please try again.', { position: toast.POSITION.TOP_CENTER, hideProgressBar: true }))
      .then(() => closeModal());
  };

  return { open, openModal, closeModal, printers, loading, selected, setSelected, confirmPrint };
}
